import React, { useState } from 'react';
import styles from 'sections/works/works.module.css';
import { useTranslation } from 'react-i18next';

import { Popup } from 'components/popup/Popup';
import { WorksPopup } from 'sections/works/WorksPopup';
import { IWorksItemProps } from 'sections/works/interfaces';
import { WorksItemImage } from 'sections/works/WorksItemImage';
import FullscreenPlayer from 'components/fullscreenPlayer/FullscreenPlayer';

export const WorksItem = ({ item }: IWorksItemProps) => {
    const { imageUrl, title, subtitle, videoUrl } = item;
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const { t } = useTranslation();

    const openClosePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    return (
        <div className={styles.works__item}>
            <div className={styles.item__img}>
                <WorksItemImage imageUrl={imageUrl} title={title} />
            </div>

            <h4 className={styles.item__title}>{title}</h4>
            <p className={styles.item__subtitle}>{subtitle}</p>
            <button className={styles.item__button} onClick={openClosePopup}>
                <span>{t('works.viewDetailsBtnText')}</span>
            </button>

            <Popup isOpen={isPopupOpen} onClose={openClosePopup}>
                <WorksPopup item={item} onClose={openClosePopup}>
                    {videoUrl ? (
                        <>
                            <FullscreenPlayer
                                videoUrl={videoUrl}
                                imageUrl={imageUrl}
                            />
                        </>
                    ) : (
                        <WorksItemImage imageUrl={imageUrl} title={title} />
                    )}
                </WorksPopup>
            </Popup>
        </div>
    );
};
